var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOesCouleur1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6678_34603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2633 36.7364C71.4077 36.7364 79.6315 28.5127 79.6315 18.3682C79.6315 8.22369 71.4077 0 61.2633 0C51.1188 0 42.895 8.22369 42.895 18.3682C42.895 28.5127 51.1188 36.7364 61.2633 36.7364Z",
    fill: "url(#paint0_radial_6678_34603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2635 30.6579C68.0504 30.6579 73.5524 25.156 73.5524 18.369C73.5524 11.5821 68.0504 6.08008 61.2635 6.08008C54.4765 6.08008 48.9746 11.5821 48.9746 18.369C48.9746 25.156 54.4765 30.6579 61.2635 30.6579Z",
    fill: "#FFD100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3716 31.1403V30.1904C30.3716 27.5599 32.0767 25.6602 34.6583 25.6602C35.4622 25.6602 36.2416 25.7089 36.9965 25.9037V28.8996C36.4607 28.7778 35.9005 28.729 35.3647 28.729C34.4635 28.729 33.952 29.2648 33.952 30.3121V31.1403H37.4107V34.1361H33.952V43.8056H30.3716V34.1361H28.0579V31.1403H30.3716Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6645 41.5892C11.3737 43.3185 9.37649 44.171 6.96523 44.171C2.80031 44.171 0.315977 41.5162 0.315977 37.5217C0.315977 33.5273 3.19001 30.6533 6.81912 30.6533C10.4481 30.6533 12.8351 33.3325 12.8351 37.2052C12.8351 37.6435 12.8107 38.0089 12.7376 38.5447H4.11555C4.40782 40.5662 5.57691 41.2483 7.08703 41.2483C8.59709 41.2483 9.52261 40.6393 10.1559 39.2754L12.6645 41.5892ZM6.72165 33.5761C5.40642 33.5761 4.43217 34.331 4.1399 36.1091H9.03553V36.0604C9.03553 34.6234 8.25613 33.5761 6.72165 33.5761Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 43.8056H14.6619V31.1404H18.2422V32.6749C19.046 31.3352 20.3125 30.6533 22.0662 30.6533C25.0863 30.6533 26.6694 32.6749 26.6694 36.2795V43.8056H23.0891V37.0589C23.0891 34.8425 22.4802 33.9658 20.8239 33.9658C19.1677 33.9658 18.2422 35.1592 18.2422 37.3025V43.8056Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1921 43.8056H57.7724V37.3025C57.7724 35.1592 58.698 33.9658 60.3542 33.9658C62.0104 33.9658 62.6194 34.8425 62.6194 37.0589V43.8056H66.1996V36.2795C66.1996 32.6749 64.6165 30.6533 61.5964 30.6533C59.8427 30.6533 58.5762 31.3352 57.7724 32.6749V31.1404H54.1921V43.8056Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3032 44.171C46.1299 44.171 47.4694 43.4647 48.4193 42.393L48.8578 43.8056H52.1702L51.8049 41.6136V31.1404H48.2245V32.2608C47.299 31.2866 45.9838 30.6533 44.2788 30.6533C40.5523 30.6533 37.8974 33.5516 37.8974 37.4731C37.8974 41.3944 40.5767 44.171 44.3032 44.171ZM45.0095 40.9316C43.1828 40.9316 41.624 39.6164 41.624 37.4731C41.624 35.3297 43.1828 33.8927 45.0095 33.8927C46.7144 33.8927 48.3463 35.2079 48.3463 37.4731C48.3463 39.7381 46.7144 40.9316 45.0095 40.9316Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6482 43.8047C76.1855 43.9995 74.7728 44.1213 74.31 44.1213C71.2655 44.1213 69.658 42.8061 69.658 39.6885V34.1353H67.3441V31.1395H69.658V27.34H73.2384V31.1395H76.7457V34.1353H73.2384V39.2014C73.2384 40.5166 73.6524 40.9063 74.8215 40.9063C75.2843 40.9063 76.1367 40.8089 76.6482 40.6872V43.8047Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4066 63.9993C42.8178 63.9993 44.8151 63.1468 46.106 61.4176L43.5972 59.1037C42.964 60.4677 42.0384 61.0765 40.5284 61.0765C39.0183 61.0765 37.8492 60.3946 37.5569 58.373H46.179C46.2521 57.8372 46.2764 57.4719 46.2764 57.0334C46.2764 53.1608 43.8896 50.4817 40.2605 50.4817C36.6314 50.4817 33.7573 53.3557 33.7573 57.3501C33.7573 61.3444 36.2417 63.9993 40.4066 63.9993ZM37.5813 55.9374C37.8735 54.1594 38.8478 53.4044 40.1631 53.4044C41.6975 53.4044 42.4769 54.4517 42.4769 55.8887V55.9374H37.5813Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3745 45.7317H31.9549V63.6335H28.3745V45.7317Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7731 45.7317H54.1927V63.6335H57.7731V45.7317Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2682 47.7039C52.2682 48.9461 51.2696 49.9447 50.0274 49.9447C48.7853 49.9447 47.7866 48.9218 47.7866 47.7039C47.7866 46.4861 48.7853 45.4875 50.0274 45.4875C51.2696 45.4875 52.2682 46.4861 52.2682 47.7039Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8054 63.6329H48.225V50.9677H51.8054V63.6329Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16211 63.9993C9.13361 63.9993 11.8128 62.7816 11.8128 59.8588C11.8128 56.7328 8.88331 56.1905 6.60516 55.7688C5.15579 55.5005 3.97005 55.281 3.97005 54.476C3.97005 53.6966 4.62767 53.2339 5.77241 53.2339C7.25817 53.2339 8.23242 53.9402 8.30547 55.3285L11.6666 54.0863C11.1064 51.8699 8.93876 50.4817 5.77241 50.4817C2.82532 50.4817 0.316624 52.2596 0.316624 54.7196C0.316624 57.7557 3.08078 58.2725 5.29605 58.6866C6.7773 58.9636 8.01315 59.1946 8.01315 60.1023C8.01315 60.8086 7.11195 61.2471 6.16211 61.2471C4.77381 61.2471 3.48294 60.7113 3.36115 58.9089L0 60.3459C0.487116 62.8059 2.94709 63.9993 6.16211 63.9993Z",
    fill: "#F05129"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7432 57.2527C26.7432 61.174 23.7961 63.9993 19.753 63.9993C15.7099 63.9993 12.7627 61.1983 12.7627 57.2527C12.7627 53.3069 15.7099 50.4817 19.753 50.4817C23.7961 50.4817 26.7432 53.3313 26.7432 57.2527ZM16.4893 57.2527C16.4893 59.396 17.9019 60.7113 19.753 60.7113C21.604 60.7113 23.0167 59.4204 23.0167 57.2527C23.0167 55.0849 21.604 53.7697 19.753 53.7697C17.9019 53.7697 16.4893 55.1093 16.4893 57.2527Z",
    fill: "#F05129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6678_34603",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2633 18.3682) scale(18.3682 18.3682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFD102",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFD208",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFD413",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFD623",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFD938",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FFDD51",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE26F",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFE792",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFEDB8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEBC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6678_34603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOesCouleur1);
export default __webpack_public_path__ + "static/media/Logo_OES_couleur1.d5de529cec86574f8bdcb05f1aad92fa.svg";
export { ForwardRef as ReactComponent };